import {
	EActionState,
	IScheduledAction,
	IScheduledActionGroup
} from '@/models';

export interface IScheduledActionState {
	data: IScheduledActionGroup[];
	loaded: EActionState;
	page: number;
	query: string;
}

export const initialScheduledActionState: IScheduledActionState = {
	data: [],
	loaded: EActionState.PENDING,
	page: 1,
	query: ''
};

export interface ITrackedScheduledActionState {
	data: IScheduledAction;
	loaded: EActionState;
}

export interface IScheduleState {
	init: EActionState;
	actions: IScheduledActionState;
	previousState: IScheduledActionState;
	selectedActions: IScheduledAction[];
	triggerState: EActionState;
	tracker: {
		actions: ITrackedScheduledActionState[];
		open: boolean;
		selected: IScheduledAction | null;
	};
}

export const initialState: IScheduleState = {
	init: EActionState.PENDING,
	actions: initialScheduledActionState,
	previousState: initialScheduledActionState,
	selectedActions: [],
	triggerState: EActionState.PENDING,
	tracker: {
		actions: [],
		open: true,
		selected: null
	}
};
